import { LegalLayout } from "../components/LegalLayout";

export function TermsPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms of Service"
      lastUpdated="13 May 2026"
    >
      <h2>What Varo is</h2>
      <p>
        Varo is a digital business card service at <strong>varo.biz</strong>. We let you
        publish a public profile at <code>varo.biz/your-handle</code> with your name,
        contact details, social links, a short video, and an about section.
        Anyone with the link can read your public profile. You can edit or delete
        it at any time.
      </p>

      <h2>Your account</h2>
      <p>
        You sign up with an email address and a password (we store the password
        only as a one-way bcrypt hash). You're responsible for keeping your
        credentials safe and for what your account does. Don't share login
        credentials. We may suspend or terminate accounts that violate these
        terms or that are used to harass, impersonate, or harm others.
      </p>

      <h2>Username policy</h2>
      <p>
        Usernames are lowercase letters, digits, and single hyphens, 3–32
        characters. Reserved words (<code>admin</code>, <code>api</code>,{" "}
        <code>login</code>, and a few dozen others) can't be claimed.
        Usernames are first-come, first-served. We may reclaim a username and
        give it to a verified trademark holder if there's a clear conflict —
        in which case we'll notify you and give you a reasonable window to
        export your data or pick a new handle.
      </p>

      <h2>Acceptable use</h2>
      <p>
        You keep what you create. Don't post anything illegal, hateful,
        threatening, sexually explicit, or that impersonates someone else
        without their consent. Don't use Varo to send spam, run phishing
        campaigns, or distribute malware. Don't scrape the API at a rate that
        affects other users — there's a rate limit; respect it.
      </p>

      <h2>Service availability</h2>
      <p>
        Varo is provided as-is, with no uptime guarantee on the free tier.
        We do our best — the service runs on Render with managed Postgres and
        Cloudflare R2 — but we may go down for maintenance, suffer outages from
        upstream providers, or change the service materially with notice.
      </p>

      <h2>Liability</h2>
      <p>
        To the extent permitted by law, Varo, its operators, and its hosts are
        not liable for indirect, incidental, or consequential damages arising
        from use of the service. If you depend on your Varo profile for
        anything important, keep a local backup of your data and your contacts.
      </p>

      <h2>Changes to these terms</h2>
      <p>
        We may update these terms occasionally. Material changes will be
        announced on your dashboard the next time you sign in. Continued use
        of the service after a change means you accept the new terms.
      </p>

      <h2>Migrated accounts</h2>
      <p>
        If your account was migrated from Mobilocard (the previous platform),
        your existing data — including bcrypt-hashed password — was carried
        over unchanged. Your old password still works. The terms above apply
        to your migrated account from the moment you next sign in.
      </p>
    </LegalLayout>
  );
}
